/**
 * Handles inline variant selection on product cards (no modal).
 * Updates hidden variant id input and submit button state when option is selected.
 * Also handles open_quick_mob_btn click to toggle active class on product-card-quick-add.
 * On mobile: moves quick_multi_cont to body when active to avoid parent z-index stacking issues.
 */
(function () {
  const MOBILE_BREAKPOINT = '(max-width: 1024px)';

  function isMobile() {
    return window.matchMedia(MOBILE_BREAKPOINT).matches;
  }

  function moveQuickAddToBody(quickAdd) {
    if (!quickAdd.classList.contains('quick_multi_cont') || !isMobile()) return;
    quickAdd._quickAddOriginalParent = quickAdd.parentElement;
    quickAdd.classList.add('quick-add-body-portal');
    document.body.appendChild(quickAdd);
  }

  function moveQuickAddBack(quickAdd) {
    if (!quickAdd._quickAddOriginalParent) return;
    quickAdd.classList.remove('quick-add-body-portal');
    quickAdd._quickAddOriginalParent.appendChild(quickAdd);
    quickAdd._quickAddOriginalParent = null;
  }

  function initOpenQuickMobBtn() {
    document.querySelectorAll('.open_quick_mob_btn').forEach((btn) => {
      if (btn.dataset.openQuickInitialized) return;
      btn.dataset.openQuickInitialized = 'true';

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const id = btn.getAttribute('data-open_quick-id');
        const target = document.querySelector(`.product-card-quick-add[data-open_quick-id="${id}"]`);
        if (target) {
          const wasActive = target.classList.contains('active');
          target.classList.toggle('active');
          const isActive = target.classList.contains('active');
          document.body.classList.toggle('overflow-hidden', isActive);
          document.body.classList.toggle('body-quick-add-active', isActive);

          if (target.classList.contains('quick_multi_cont') && isMobile()) {
            if (isActive) {
              moveQuickAddToBody(target);
            } else {
              moveQuickAddBack(target);
            }
          }
        }
      });
    });
  }

  // Close quick-add panel when clicking .close_quick_add_mob_btn
  function initCloseQuickMobBtn() {
    document.querySelectorAll('.close_quick_add_mob_btn').forEach((btn) => {
      if (btn.dataset.closeQuickInitialized) return;
      btn.dataset.closeQuickInitialized = 'true';

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const quickAdd = btn.closest('.product-card-quick-add');
        if (quickAdd) {
          quickAdd.classList.remove('active');
          document.body.classList.remove('overflow-hidden');
          document.body.classList.remove('body-quick-add-active');
          moveQuickAddBack(quickAdd);
        }
      });
    });
  }

  function initCardProductInline() {
    document.querySelectorAll('.card-product-inline-quick-add').forEach((wrapper) => {
      if (wrapper.dataset.initialized) return;
      wrapper.dataset.initialized = 'true';

      const form = wrapper.querySelector('form');
      const variantInput = wrapper.querySelector('.product-variant-id');
      const submitButton = wrapper.querySelector('[type="submit"]');
      const qaLabel = submitButton?.querySelector('.qa-label');
      const soldOutMessage = submitButton?.querySelector('.sold-out-message');
      const addToCartText = wrapper.dataset.addToCartText || (window.variantStrings?.addToCart || 'Add to bag');

      form?.addEventListener('submit', (e) => {
        if (!variantInput?.value) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      }, true);

      wrapper.querySelectorAll('.card-product-inline-option-input').forEach((radio) => {
        radio.addEventListener('change', () => {
          const variantId = radio.dataset.variantId;
          const available = radio.dataset.available === 'true';

          if (variantInput && variantId) {
            variantInput.value = variantId;
            variantInput.disabled = !available;
          }

          if (submitButton) {
            submitButton.disabled = !available;
            if (qaLabel) {
              qaLabel.textContent = available ? addToCartText : (window.variantStrings?.soldOut || 'Sold out');
            }
            if (soldOutMessage) {
              soldOutMessage.classList.toggle('hidden', available);
              qaLabel?.classList.toggle('hidden', !available);
            }
          }

          wrapper.classList.toggle('variant-selected', !!variantId);

          // Update quick view price spans with variant price data
          const priceCents = parseInt(radio.getAttribute('price'), 10);
          const compareAtPriceCents = parseInt(radio.getAttribute('compare_at_price'), 10) || 0;
          const productId = wrapper.dataset.productId;
          if (productId && !isNaN(priceCents)) {
            // Use wrapper when in body (portal), otherwise card-product for card price
            const priceRoot = wrapper.closest('.card-product') || wrapper;
            if (priceRoot) {
              const vatRate = 0.15;
              const priceExcluding = priceCents;
              const priceIncluding = Math.round(priceCents * (1 + vatRate));
              const moneyFormat = wrapper.dataset.moneyFormat || '${{amount}}';
              const moneyWithCurrencyFormat = wrapper.dataset.moneyWithCurrencyFormat || '${{amount}} USD';
              const currencyCodeEnabled = wrapper.dataset.currencyCodeEnabled === 'true';
              const formatString = currencyCodeEnabled ? moneyWithCurrencyFormat : moneyFormat;
              const formatMoney = (cents) => {
                if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
                  return Shopify.formatMoney(cents, formatString);
                }
                const currency = wrapper.dataset.currency || '';
                return (cents / 100).toFixed(2) + (currency ? ` ${currency}` : '');
              };
              const formattedExcluding = formatMoney(priceExcluding);
              const formattedIncluding = formatMoney(priceIncluding);
              priceRoot.querySelectorAll(`[data-price-quick-excluding="${productId}"]`).forEach((el) => {
                el.textContent = formattedExcluding;
              });
              priceRoot.querySelectorAll(`[data-price-quick-including="${productId}"]`).forEach((el) => {
                el.textContent = formattedIncluding;
              });
              priceRoot.querySelectorAll('.price').forEach((priceContainer) => {
                priceContainer.classList.toggle('price--on-sale', compareAtPriceCents > priceCents);
              });
            }
          }
        });
      });
    });
  }

  function init() {
    initCardProductInline();
    initOpenQuickMobBtn();
    initCloseQuickMobBtn();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init for dynamic content (e.g. Shopify sections, product recommendations loaded via fetch)
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('product-recommendations:loaded', init);
})();
